import mountNotesApp from '~/mr_notes/mount_app';
import { initMrPage } from '~/pages/projects/merge_requests/page';

initMrPage();
mountNotesApp();
